import React, { useContext, useEffect, useState } from "react";
import { simplifyUrl } from "../../../../../hooks/utils";
import { csrfToken } from "../../../../../utis/csrfTokenUtils";
import { getNormalizedDimensions, gifProportion, constProportionRespectUserDrawnBox,fitImageIntoDrawnBox, normalizeDimensions, roundTripSafeNormalize ,applyProportionalResize} from "../../../../../utis/helper";
import { EditorInfoContext } from "../../../../../utis/userInfoContext";
import { networkService } from "../../../../config/axios";
import EmbedSection from "../elementModal/elementSections/embedSection/EmbedSection";
import HotspotSection from "../elementModal/elementSections/hotspotSection/HotspotSection";
import ImageSection from "../elementModal/elementSections/imageSection/ImageSection";
import TextEditorSection from "../elementModal/elementSections/textEditorSection/TextEditorSection";
import VideoSection from "../elementModal/elementSections/videoSection/VideoSection";
import _ from "lodash";
export const actionKeys = ['page_link', 'url', 'link_title', 'kdf', 'link', 'kdf_title', 'light_box', 'lj_url', 'lj_mail', 'lj_phone', 'lj_page_link']
const useEditorHook = (closeModal, docData, totalPages, zoom, applyDesiredAction) => {
    const {
        setEditEnabled,
        geo,
        toolType,
        elements,
        editElement,
        imageElement,
        setEditElement,
        setElements,
        setToolType,
        setImageElement,
        setShowToast,
        pageDimensions
    } = useContext(EditorInfoContext)

    // initial state for the element mpdal fields
    const [tool, setTool] = useState({
        // properties going to be hadled dynamically
        authenticity_token: csrfToken(),
        doc_id: docData?.doc_id,
        docs_file_id: docData?.id,
        other_files: [],
        other_files_element: [],
        value: editElement?.value ?? { no_scroll: true, timerField: "ViewPort" },
        page: editElement?.page ?? geo.page,
        geometry: {
            ...(toolType !== 'LightboxesToolbox' && {
                left: editElement?.geometry?.left ?? geo?.width == 0 ? geo?.left - 50 : geo?.left,
                top: editElement?.geometry?.top ?? geo?.height == 0 ? geo?.top - 50 : geo?.top,
                width: editElement?.geometry?.width ?? (geo?.width < 50 && geo?.height < 50) ? 50 : geo?.width,
                height: editElement?.geometry?.height ?? (geo?.width < 50 && geo?.height < 50) ? 50 : geo?.height,
            }),
            keep_proportions: editElement?.geometry?.keep_proportions ?? (toolType == 'TextToolbox' || toolType == 'HotspotToolbox' || toolType == 'EmbedToolbox') ? false : true,
            keep_within_page: editElement?.geometry?.keep_within_page ?? true,
            hide_beyond_page_edges: editElement?.geometry?.hide_beyond_page_edges ?? false
        },
        sec_to_delay: editElement?.sec_to_delay ?? 0,
        disappear_after: 0,
        priority: editElement?.priority ?? (toolType === 'VideoToolbox' ? true : false),
        jump_to_page: '',
        action: 'none',
        disappear_after: editElement?.disappear_after ?? 0,
        scrolling : false,
        ...(editElement?.gif_type && { gif_type: editElement?.gif_type }),
    })

    // error state 
    const [errorState, setErrorState] = useState({
        videoErr: '',
        embedErr: '',
        textErr: '',
        imgErr: '',
        dimensionError: '',
        tagErr: '',
        pageErr: '',
        ljErr: ''
    })
    const [initialTool, setInitialTool] = useState(tool);
    const [initialEditElement, setInitialEditElement] = useState(editElement);
    const [isChanged, setIsChanged] = useState(false);
    //new for error boundry
    const [showExtendModal, setShowExtendModal] = useState(false);
    const [scrollActive, setScrollActive] = useState(() => {
        // Load initial state from sessionStorage
        const saved = sessionStorage.getItem("scrolling");
        return saved === "true"; // default: false
      });

        const handleSubmitBtnState = () => {
                const generalChanges = !_.isEqual(tool, initialTool) || !_.isEqual(editElement, initialEditElement);
                const tagsChanged = !_.isEqual(tool.tags, initialTool.tags);
                const flipChanged = !_.isEqual(tool.flip, initialTool.flip);
                const hasChanged = generalChanges || tagsChanged || flipChanged;            
                setIsChanged(hasChanged);
            };   

    useEffect(() => {
        sessionStorage.setItem("scrolling", scrollActive);
        if (!Object.values(editElement).length > 0) {
            handleSubmitBtnState();
        }
    }, [tool, editElement]);

    //handle text editor change 
   const handleChange = (e) => {
  const { name, type, value, checked } = e.target;
  const actionNames = [
    "jump_to_page",
    "href",
    "kdf",
    "light_box",
    "link_title",
    "kdf_title",
    "action",
    "desiredaction",
    "thisElement",
    "frequency_animation",
    "timerField",
    "link_and_jump_page",
    "link_and_jump_url",
  ];

  if (name === "scrolling") {
  setScrollActive(checked);
  setTool((prev) => ({
    ...prev,
    value:{
      ...prev.value,
      reactivate_scroll : checked,
      reactive : checked ? "reactive" :''
    }
    
  }));
  handleSubmitBtnState();
  return;
}

  if (name === "action") {
    document.querySelectorAll("input[name='action']").forEach((radio) => {
      radio.checked = false;
    });
    e.target.checked = true;
  }

  switch (true) {
    case name === "bg_color": {
      setTool((prev) => ({
        ...prev,
        value: {
          ...prev.value,
          [name]: value,
        },
      }));
      break;
    }

    case name === "transparency": {
      setTool((prev) => ({
        ...prev,
        [name]: value,
      }));
      break;
    }


case name.startsWith("geometry."): {
  localStorage.setItem("is_changed_model", "true");

  const geometryKey = name.split(".")[1];
  const parsedValue =
    type === "checkbox" ? checked : value !== "" ? Number(value) : value;

  setTool((prev) => {
    const prevGeo = prev.geometry || {};
    
    // For images, use file_details dimensions; for videos/embeds, use embed_dimensions
    let originalImageWidth, originalImageHeight;
    
    if (prev.file_details?.dimensions?.width && prev.file_details?.dimensions?.height) {
      // Image element
      originalImageWidth = prev.file_details.dimensions.width;
      originalImageHeight = prev.file_details.dimensions.height;
    } else if (prev.embed_dimensions?.width && prev.embed_dimensions?.height) {
      // Video/embed element with stored embed dimensions
      originalImageWidth = prev.embed_dimensions.width;
      originalImageHeight = prev.embed_dimensions.height;
    } else if (prev.value?.embed_dimensions?.width && prev.value?.embed_dimensions?.height) {
      // Video/embed element with dimensions stored in value
      originalImageWidth = prev.value.embed_dimensions.width;
      originalImageHeight = prev.value.embed_dimensions.height;
    } else {
      // Fallback to current geometry dimensions
      originalImageWidth = prevGeo.width || 1;
      originalImageHeight = prevGeo.height || 1;
    }
    
    let newGeo = {
      ...prevGeo,
      [geometryKey]: parsedValue,
    };

    // Make keep_within_page and hide_beyond_page_edges mutually exclusive
    if (geometryKey === "keep_within_page" && parsedValue === true) {
      newGeo.hide_beyond_page_edges = false;
    }
    if (geometryKey === "hide_beyond_page_edges" && parsedValue === true) {
      newGeo.keep_within_page = false;
    }

    if (geometryKey === "keep_proportions") {
      newGeo.keep_proportions = parsedValue;
    }

    // Maintain original aspect ratio (for both images and videos/embeds)
    if (
      newGeo.keep_proportions &&
      (geometryKey === "width" || geometryKey === "height")
    ) {
      const aspectRatio = originalImageWidth / originalImageHeight;

      if (geometryKey === "width") {
        const width = parsedValue;
        const height = Math.round(width / aspectRatio);
        newGeo.width = width;
        newGeo.height = height;
      } else if (geometryKey === "height") {
        const height = parsedValue;
        const width = Math.round(height * aspectRatio);
        newGeo.height = height;
        newGeo.width = width;
      }
    }

    // Check for boundary overflow
    const pageWidth = pageDimensions?.width;
    const pageHeight = pageDimensions?.height;
    const newLeft = newGeo.left ?? prevGeo.left ?? 0;
    const newTop = newGeo.top ?? prevGeo.top ?? 0;

    let isExtendingBeyond = false;

    if (["width", "height", "left", "top"].includes(geometryKey)) {
      const finalWidth = newGeo.width ?? prevGeo.width ?? 0;
      const finalHeight = newGeo.height ?? prevGeo.height ?? 0;

      if (pageWidth && newLeft + finalWidth > pageWidth) isExtendingBeyond = true;
      if (pageHeight && newTop + finalHeight > pageHeight) isExtendingBeyond = true;

      if (newLeft < 0) isExtendingBeyond = true;
      if (newTop < 0) isExtendingBeyond = true;
    }

    const shouldKeepWithinPage = newGeo.keep_within_page !== false;
    if (isExtendingBeyond && shouldKeepWithinPage) {
      setShowExtendModal(true);
    } else {
      setShowExtendModal(false);
    }

    // Clear base geometry for user-modified dimensions to prevent rounding drift on save
    let updatedBaseGeo = prev._baseGeometry ? { ...prev._baseGeometry } : undefined;
    if (updatedBaseGeo && ["width", "height", "top", "left"].includes(geometryKey)) {
      updatedBaseGeo[geometryKey] = undefined;
      if (newGeo.keep_proportions && (geometryKey === "width" || geometryKey === "height")) {
        updatedBaseGeo.width = undefined;
        updatedBaseGeo.height = undefined;
      }
    }

    return {
      ...prev,
      geometry: newGeo,
      ...(updatedBaseGeo !== undefined && { _baseGeometry: updatedBaseGeo }),
    };
  });

  break;
}


    case ["animation", "frequency", "disappear", "timerField", "disappear_after"].includes(
      name
    ): {
      setTool((prev) => ({
        ...prev,
        ...(name === "disappear_after" && { disappear_after: Number(value) }),
        value: {
          ...prev.value,
          ...(name === "disappear_after" && value == 0
            ? { disappear: "" }
            : { [name]: value }),
        },
      }));
      break;
    }

    case actionNames.includes(name) || value === "desiredaction" || value === "page": {
      setErrorState({ ...errorState, pageErr: "" });

      setTool((prev) => {
        let updatedValue = { ...prev?.value } || {};
        let actionValue = name;
        let dropdown_data = {};

        if (name === "action" && value === "none") {
          updatedValue = {};
          actionValue = "none";
        } else if (
          ["desiredaction", "thisElement", "frequency_animation", "timerField"].includes(
            name
          ) ||
          value === "desiredaction"
        ) {
          actionValue = "desiredaction";
          dropdown_data =
            value === "desiredaction"
              ? {
                  frequency: "OnEveryClick",
                  thisElement: "thisElement",
                  desiredaction: "hide",
                }
              : {
                  ...prev.dropdown_data,
                  ...(name === "frequency_animation"
                    ? { frequency: value }
                    : { [name]: value }),
                };
          updatedValue = {};
        } else if (["jump_to_page", "page"].includes(name)) {
          if (Number(value) === tool?.page) {
            setErrorState((prevErr) => ({
              ...prevErr,
              pageErr: "Please add a page number other than current page",
            }));
          } else {
            setErrorState((prevErr) => ({
              ...prevErr,
              pageErr: "",
            }));
          }
          updatedValue = { page_link: value };
          actionValue = "page";
        } else if (value === "on" || name === "light_box") {
          updatedValue = { light_box: value };
          actionValue = "on";
        } else if (name === "href") {
          updatedValue = {};
          if (!value.trim() || value === "https://" || value === "@") {
            updatedValue = {};
          } else if (value.includes("@")) {
            // Any value with @ is treated as email (including partial input like "user@domain").
            // Full regex validation only when complete — don't prepend https:// mid-typing.
            if (/\S+@\S+\.\S+/.test(value)) {
              updatedValue.mail = value; // complete email
            } else {
              updatedValue.mail = value; // partial email — store as-is, no https://
            }
          } else if (/^\+?\d+$/.test(value)) {
            updatedValue.phone = value;
          } else {
            updatedValue.url = value.startsWith("https://")
              ? value
              : `https://${value}`;
          }
          actionValue = "href";
        } else if (value === "link_and_jump" || name === "link_and_jump_page" || name === "link_and_jump_url") {
          actionValue = "link_and_jump";
          setErrorState((prevErr) => ({ ...prevErr, ljErr: "" }));
          if (value === "link_and_jump") {
            // Radio button selected - preserve existing lj_ values
            updatedValue = {};
            if (prev?.value?.lj_url) updatedValue.lj_url = prev.value.lj_url;
            if (prev?.value?.lj_mail) updatedValue.lj_mail = prev.value.lj_mail;
            if (prev?.value?.lj_phone) updatedValue.lj_phone = prev.value.lj_phone;
            if (prev?.value?.lj_page_link) updatedValue.lj_page_link = prev.value.lj_page_link;
          } else if (name === "link_and_jump_url") {
            // URL/email/phone input changed - preserve lj_page_link
            updatedValue = {};
            if (prev?.value?.lj_page_link) updatedValue.lj_page_link = prev.value.lj_page_link;
            if (!value.trim() || value === "https://" || value === "@") {
              // empty
            } else if (value.includes("@")) {
              // Any value with @ is treated as email — don't prepend https:// mid-typing
              updatedValue.lj_mail = value;
            } else if (/^\+?\d+$/.test(value)) {
              updatedValue.lj_phone = value;
            } else {
              updatedValue.lj_url = value.startsWith("https://") ? value : `https://${value}`;
            }
          } else if (name === "link_and_jump_page") {
            // Page input changed - preserve lj_ link values
            if (Number(value) === tool?.page) {
              setErrorState((prevErr) => ({
                ...prevErr,
                pageErr: "Please add a page number other than current page",
              }));
            } else {
              setErrorState((prevErr) => ({
                ...prevErr,
                pageErr: "",
              }));
            }
            updatedValue = {};
            if (prev?.value?.lj_url) updatedValue.lj_url = prev.value.lj_url;
            if (prev?.value?.lj_mail) updatedValue.lj_mail = prev.value.lj_mail;
            if (prev?.value?.lj_phone) updatedValue.lj_phone = prev.value.lj_phone;
            updatedValue.lj_page_link = value;
          }
        } else if (["link_title", "kdf_title"].includes(name)) {
          updatedValue = {
            link_title:
              name === "link_title" ? value : updatedValue.link_title,
            kdf_title:
              name === "kdf_title" ? value : updatedValue.kdf_title,
          };
          actionValue = "kdf";
        } else {
          updatedValue[name] = value;
        }

        // Clear all action keys to prevent conflicts when switching actions
        const prevValueWithoutActions = Object.keys(prev?.value || {})
          .filter(key => !actionKeys.includes(key))
          .reduce((obj, key) => {
            obj[key] = prev.value[key];
            return obj;
          }, {});

        return {
          ...prev,
          dropdown_data,
          actual_page: geo?.page,
          action: actionValue,
          value: {
            ...prevValueWithoutActions,
            ...updatedValue,
          },
        };
      });

      break;
    }

    case name === "flip": {
      setTool((prev) => ({
        ...prev,
        flip: type === "checkbox" ? checked : value,
      }));
      break;
    }

    case name === "tags": {
      setTool((prev) => ({
        ...prev,
        tags: value,
      }));
      break;
    }

    default: {
      // Validate SHOW ON PAGE against JUMP TO PAGE
      if (name === "page") {
        const pageValue = value === "" ? "" : Number(value) || 1;
        const jumpToPageValue = tool?.jump_to_page !== undefined ? tool?.jump_to_page : tool?.value?.page_link;
        
        if (jumpToPageValue !== undefined && jumpToPageValue !== null && jumpToPageValue !== "" && Number(pageValue) === Number(jumpToPageValue)) {
          setErrorState((prevErr) => ({
            ...prevErr,
            pageErr: "Please add a page number other than current page",
          }));
        } else {
          setErrorState((prevErr) => ({
            ...prevErr,
            pageErr: "",
          }));
        }
      }
      
      setTool((prev) => ({
        ...prev,
        [name]:
          type === "checkbox"
            ? checked
            : type === "number"
            ? name === "page"
              ? value === ""
                ? ""
                : Number(value) || 1
              : Number(value)
            : value,
      }));
      break;
    }
  }

  handleSubmitBtnState();
};

    const handleTextChange = (data) => {
        setTool((prevValues) => ({
            ...prevValues,
            element_type: 7,
            value: {
                ...prevValues.value,
                html_text: data,
                timerField: "ViewPort"
            },
        }));
        setErrorState({
            ...errorState,
            textErr: ''
        })
        handleSubmitBtnState();
    }

    // handle the select the gifs and tenor
    const handleSelectGifs = (type, url, dimensions) => {
        setErrorState({ ...errorState, imgErr: '' })
        let _gifProportion = gifProportion(tool?.geometry?.width, tool?.geometry?.height, dimensions?.width, dimensions?.height);
        setTool({
            ...tool,
            _baseGeometry: tool._baseGeometry ? {
                ...tool._baseGeometry,
                width: undefined,
                height: undefined,
            } : undefined,
            geometry: {
                ...tool?.geometry,
                width: _gifProportion[0],
                height: _gifProportion[1],
            },
            gif_type: type,
            image_text: "",
            image_type: null,
            element_type: '4',
            rotate: 0,
            flip: 1,
            is_tenor: type == 'tenor',
            recurrence: "OncePerVisit",
            value: { ...tool?.value, timerField: "ViewPort", gif_link: url , reactivate_scroll: tool?.value.reactivate_scroll }
        })
        handleSubmitBtnState();
    }

    const isImageFile = (file) => {
        if (!file.type.startsWith('image/')) {
            return false;
        }
        return true;
    };

    const handleImageUpload = (event, action) => {
      setEditEnabled(false);

      if (action === "cancel") {
        setTool({ ...tool, file: "" });
        handleSubmitBtnState();
        return;
      }

      if (action === "upload") {
        const file = event.target.files?.[0];
        setErrorState((prev) => ({ ...prev, imgErr: "" }));

        if (!file || !isImageFile(file)) {
          setErrorState((prev) => ({
            ...prev,
            imgErr: "Please upload a valid image file.",
          }));
          event.target.value = null;
          return;
        }

        const img = new Image();
        img.src = URL.createObjectURL(file);

        img.onload = () => {
          const imgWidth = img.width;
          const imgHeight = img.height;

          // Use editElement geometry as source of truth for saved position when replacing image
          // This ensures the exact position (left, top) is preserved after dragging and saving
          const savedGeo = editElement?.geometry || {};
          const existingGeo = tool?.geometry || {};
          
          // Keep existing screen-space coords for display so modal inputs don't jump.
          // savedGeo has base coords (from DB); existingGeo has screen coords (current zoom).
          // We prefer screen coords for display; _baseGeometry handles the correct base
          // values at save time via handleSave and uploadElement.
          const preservedLeft = existingGeo.left ?? savedGeo.left ?? 0;
          const preservedTop = existingGeo.top ?? savedGeo.top ?? 0;
          const preservedWidth = existingGeo.width ?? savedGeo.width;
          const preservedHeight = existingGeo.height ?? savedGeo.height;

          // If we have saved dimensions, preserve them exactly (same size, same dimensions)
          // Otherwise, calculate dimensions based on new image
          let finalWidth, finalHeight;
          if (preservedWidth && preservedHeight) {
            // Preserve exact dimensions when replacing image variant
            finalWidth = preservedWidth;
            finalHeight = preservedHeight;
          } else {
            // Calculate dimensions for new image upload
            const targetWidth = preservedWidth || imgWidth;
            const targetHeight = preservedHeight || imgHeight;
            [finalWidth, finalHeight] = fitImageIntoDrawnBox(
              targetWidth,
              targetHeight,
              imgWidth,
              imgHeight
            );
          }

          // If finalWidth/Height differs from the current screen values, dimensions changed
          // (e.g. fitImageIntoDrawnBox produced new values). Clear _baseGeometry for those
          // fields so handleSave uses roundTripSafeNormalize instead of stale base values.
          const dimensionsChanged =
            finalWidth !== existingGeo.width || finalHeight !== existingGeo.height;

          const {
            file_url,
            file_details,
            is_tenor,
            gif_type,
            ...toolWithoutFileUrl
          } = tool;

          const { gif_link, ...updatedValue } = toolWithoutFileUrl?.value || {};

          setTool({
            ...toolWithoutFileUrl,
            original_width: imgWidth,
            original_height: imgHeight,
            file_cache: "",
            ...(toolWithoutFileUrl._baseGeometry && dimensionsChanged && {
              _baseGeometry: {
                ...toolWithoutFileUrl._baseGeometry,
                width: undefined,
                height: undefined,
              },
            }),
            geometry: {
              ...savedGeo,
              ...existingGeo,
              left: preservedLeft,
              top: preservedTop,
              width: finalWidth,
              height: finalHeight,
              keep_proportions: savedGeo.keep_proportions ?? existingGeo.keep_proportions ?? true,
            },
            transparency: toolWithoutFileUrl?.transparency ?? 1,
            element_type: "4",
            gif_type: "image",
            file: file,
            value: {
              ...updatedValue,
              timerField: "ViewPort",
              reactivate_scroll: updatedValue?.reactivate_scroll ? true:false,
            },
          });

          handleSubmitBtnState();
        };
      }
    };


    const handleElementUpload = (event, type) => {
        if (event.target?.name !== 'no_scroll') {
            const embedCode = event.target.value;
            let source = "";
            let videoLink = "";
            let embedWidth = null;
            let embedHeight = null;
            
            // SIMPLE FIX: If embed code contains <script> tag, store AS-IS (ThriveCart, etc.)
            if (/<script/i.test(embedCode)) {
                videoLink = embedCode.replace(/src="\/\//g, 'src="https://').replace(/href="\/\//g, 'href="https://');
            } else if (embedCode.match(/^<iframe(.*?)><\/iframe>/gi)) {
                // Extract URL from iframe
                videoLink = embedCode.split('src="')[1]?.split('"')[0] || "";

                // Extract width and height from iframe embed code
                const widthMatch = embedCode.match(/width=["']?(\d+)["']?/i);
                const heightMatch = embedCode.match(/height=["']?(\d+)["']?/i);

                if (widthMatch && widthMatch[1]) {
                    embedWidth = parseInt(widthMatch[1], 10);
                }
                if (heightMatch && heightMatch[1]) {
                    embedHeight = parseInt(heightMatch[1], 10);
                }
            } else {
                if (embedCode.includes('data-url="')) {
                    videoLink = embedCode.split('data-url="')[1]?.split('"')[0] || "";
                } else if (embedCode.includes('href="')) {
                    videoLink = embedCode.split('href="')[1]?.split('"')[0] || "";
                } else if (embedCode.includes('src="')) {
                    videoLink = embedCode.split('src="')[1]?.split('"')[0] || "";
                } else {
                    videoLink = embedCode; // If it's already a URL
                }
            }

            // Skip protocol handling for script embeds (already handled above)
            if (/<script/i.test(embedCode)) {
                // Script embed - keep as-is
            } else {
                // Only add https:// when user is typing (new value longer than before), not when
                // they press Delete/Backspace (new value shorter). That way we never add on delete.
                videoLink = (videoLink || "").trim();
                const previousUrl = tool?.value?.video_link || "";
                const isDeleting = embedCode.length < previousUrl.length;

            if (isDeleting) {
                // User pressed Delete/Backspace — do not add https://, only upgrade http to https if present
                if (videoLink && videoLink.toLowerCase().startsWith("http://")) {
                    videoLink = videoLink.replace(/^http:\/\//i, "https://");
                } else if (videoLink && videoLink.startsWith("//")) {
                    // Handle protocol-relative URLs (e.g., //example.com)
                    videoLink = "https:" + videoLink;
                }
            } else {
                // User is typing — add https:// when they write URL-like content without protocol
                if (!videoLink) {
                    // Empty stays empty
                } else if (videoLink.toLowerCase().startsWith("http")) {
                    if (videoLink.toLowerCase().startsWith("http://")) {
                        videoLink = videoLink.replace(/^http:\/\//i, "https://");
                    }
                } else if (videoLink.startsWith("//")) {
                    // Handle protocol-relative URLs (e.g., //example.com from ThriveCart, etc.)
                    videoLink = "https:" + videoLink;
                } else {
                    videoLink = "https://" + videoLink;
                }
            }
            } // Close the else block for protocol handling

            // Special handling for Wistia videos
            if (videoLink.includes('fast.wistia.com/embed/medias/')) {
                const match = videoLink.match(/embed\/medias\/([a-zA-Z0-9]+)\.jsonp/);
                if (match && match[1]) {
                    const wistiaId = match[1];
                    videoLink = `https://fast.wistia.net/embed/iframe/${wistiaId}`;
                    source = 'wistia';
                }
            }
    
            // Special handling for Loom videos
            if (videoLink.includes('loom.com/share/')) {
                videoLink = videoLink.replace('loom.com/share/', 'loom.com/embed/');
            } else if (videoLink.includes('loom.com/embed/')) {
                source = 'loom'; // Mark source as Loom
            }
    
            // If type is 'embed', apply necessary transformations
            if (type === 'embed') {
                if (videoLink.includes('canva')) {
                    const url = simplifyUrl(embedCode);
                    videoLink = url + "?embed";
                }
            }
    
            // Handle Facebook embeds separately
            if (videoLink.includes('facebook.com')) {
                videoLink = "https://www.facebook.com/plugins/post.php?href=" + videoLink;
            }
    
            // Detect Source Type
            if (embedCode.includes('youtube')) {
                source = 'youtube';
                
                // Validate YouTube embed code has 'si' parameter for tracking
                // Right-click embed doesn't include 'si', only Share option does
                if (videoLink && !videoLink.includes('si=')) {
                    const errorMessage = 'Please use the Embed code generated by Share button.';
                    setErrorState({ 
                        ...errorState, 
                        videoErr: type === 'video' ? errorMessage : '',
                        embedErr: type === 'embed' ? errorMessage : ''
                    });
                    // Don't proceed with setting the tool state if validation fails
                    handleSubmitBtnState();
                    return;
                }
            } else if (embedCode.includes('vimeo')) {
                source = 'vimeo';
            } else if (embedCode.includes('soundcloud')) {
                source = 'soundcloud';
            }
    
            // Get current geometry
            const existingGeo = tool?.geometry || {};
            let updatedGeometry = { ...existingGeo };
            
            // If keep_proportions is enabled and we have embed dimensions, adjust geometry to respect aspect ratio
            if (embedWidth && embedHeight && existingGeo.keep_proportions) {
                const targetWidth = existingGeo.width || embedWidth;
                const targetHeight = existingGeo.height || embedHeight;
                
                const [adjustedWidth, adjustedHeight] = fitImageIntoDrawnBox(
                    targetWidth,
                    targetHeight,
                    embedWidth,
                    embedHeight
                );
                
                updatedGeometry.width = adjustedWidth;
                updatedGeometry.height = adjustedHeight;
            }
    
            // Update State
            setTool((prevTool) => ({
                ...prevTool,
                element_type: type === 'embed' ? '6' : type === 'video' ? '5' : '8',
                other_files: [],
                other_files_element: [],
                tags: prevTool?.tags || [], // Preserve existing tags instead of resetting
                sec_to_delay: 0,
                disappear_after: 0,
                // Clear base geometry if dimensions changed due to embed aspect ratio
                ...(embedWidth && embedHeight && existingGeo.keep_proportions && prevTool._baseGeometry && {
                    _baseGeometry: {
                        ...prevTool._baseGeometry,
                        width: undefined,
                        height: undefined,
                    }
                }),
                geometry: updatedGeometry,
                // Store embed dimensions for future aspect ratio calculations (always store if available)
                ...(embedWidth && embedHeight && {
                    embed_dimensions: {
                        width: embedWidth,
                        height: embedHeight
                    }
                }),
                value: {
                    timerField: "ViewPort",
                    video_link: videoLink,
                    ...(source && { source }),
                    ...(type === 'embed' && { no_scroll: true, no_js: true }),
                    reactivate_scroll: prevTool.value?.reactivate_scroll,
                    // Also store in value for consistency
                    ...(embedWidth && embedHeight && {
                        embed_dimensions: {
                            width: embedWidth,
                            height: embedHeight
                        }
                    })
                }
            }));
    
            setErrorState({ ...errorState, videoErr: '', embedErr: '' });
        } else {
            setTool({
                ...tool,
                value: {
                    ...tool?.value,
                    ...(type === 'embed' && { no_scroll: event?.target?.checked, no_js: true })
                }
            });
        }
        handleSubmitBtnState();
    };
    
    const handleSubmitElement = (e, elemId, elementName) => {
        e?.preventDefault();
        e && uploadElement(elemId, elementName);
    };

    const handleSave = (payload) => {
        const url = `/docs/elements${payload?.id ? '/' + payload?.id : ''}.json`;
        // Normalize geometry to base coords before sending (same logic as uploadElement),
        // then strip the internal _baseGeometry tracking field from the request.
        const baseGeo = payload._baseGeometry || {};
        const { _baseGeometry, ...cleanPayload } = payload;
        const sendPayload = cleanPayload.geometry ? {
            ...cleanPayload,
            geometry: {
                ...cleanPayload.geometry,
                width:  baseGeo.width  != null ? baseGeo.width  : roundTripSafeNormalize(cleanPayload.geometry.width,  zoom.value, 1),
                height: baseGeo.height != null ? baseGeo.height : roundTripSafeNormalize(cleanPayload.geometry.height, zoom.value, 1),
                top:    baseGeo.top    != null ? baseGeo.top    : roundTripSafeNormalize(cleanPayload.geometry.top,    zoom.value, 1),
                left:   baseGeo.left   != null ? baseGeo.left   : roundTripSafeNormalize(cleanPayload.geometry.left,   zoom.value, 1),
            },
        } : cleanPayload;
        networkService(url, "PATCH", sendPayload)
            .then((response) => {
                if ((response.status == 200)) {
                    setElements(prev => ({ ...prev, [response?.data?.id]: response?.data }));
                }
            })
            .catch((error) => {
                console.error(error)
            });
    };


    const EMBED_BLOCKED_MESSAGE = 'This website restricts iframe embedding for security reasons.';

    const uploadElement = async (elementId, elementType) => {
  // For embed elements, block save if the URL restricts iframe embedding (same message as SafeIFrame fallback)
  const isEmbedElement = toolType === 'EmbedToolbox' || editElement?.element_type === 6;
  const isScriptEmbed = /<script/i.test(tool?.value?.video_link); // Script embeds don't use iframes

  if (isEmbedElement && tool?.value?.video_link && !isScriptEmbed) {
    try {
      const url = `/api/v1/embed_check?url=${encodeURIComponent(tool.value.video_link)}`;
      const resp = await fetch(url, { signal: AbortSignal.timeout(8000) });
      if (resp.ok) {
        const data = await resp.json();
        if (data.embeddable === false) {
          setErrorState((prev) => ({ ...prev, embedErr: EMBED_BLOCKED_MESSAGE }));
          return;
        }
      }
    } catch (_) {
      // Network/timeout: allow save; viewer will still show wrapper fallback if embed fails
    }
  }

  if (handleValidations(tool) || elementType === 'image') {
    // Use preserved base geometry for unchanged dimensions to prevent rounding drift
    const baseGeo = tool._baseGeometry || {};
    const updatedGeometry = {
      ...tool.geometry,
      width:  baseGeo.width  != null ? baseGeo.width  : roundTripSafeNormalize(tool.geometry.width,  zoom.value, 1),
      height: baseGeo.height != null ? baseGeo.height : roundTripSafeNormalize(tool.geometry.height, zoom.value, 1),
      top:    baseGeo.top    != null ? baseGeo.top    : roundTripSafeNormalize(tool.geometry.top,    zoom.value, 1),
      left:   baseGeo.left   != null ? baseGeo.left   : roundTripSafeNormalize(tool.geometry.left,   zoom.value, 1),
      geo:{
        ...tool.geometry.geo,
        width:  baseGeo.width  != null ? baseGeo.width  : roundTripSafeNormalize(tool.geometry.width,  zoom.value, 1),
        height: baseGeo.height != null ? baseGeo.height : roundTripSafeNormalize(tool.geometry.height, zoom.value, 1),
        top:    baseGeo.top    != null ? baseGeo.top    : roundTripSafeNormalize(tool.geometry.top,    zoom.value, 1),
        left:   baseGeo.left   != null ? baseGeo.left   : roundTripSafeNormalize(tool.geometry.left,   zoom.value, 1),
      }
    };
    // Exclude internal _baseGeometry tracking from server payload
    const { _baseGeometry: _omitBaseGeo, ...toolPayload } = tool;
    const payload = {
      ...toolPayload,
      geometry: updatedGeometry,
      ...(toolType === 'Clone' && { duplicate: true }),
        // Add scrolling flag if present on tool
       scrolling: tool.scrolling,
       value: {
      ...tool.value,
      reactivate_scroll: !!tool?.value?.reactivate_scroll,
      reactive: tool?.value?.reactivate_scroll ? "reactive" : ""
    },
    };
    const formData = new FormData();
    const headers = {
      'X-CSRF-Token': document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute('content'),
    };

    const sanitizedPayload = Object.entries(payload).reduce((acc, [key, value]) => {
      if (Array.isArray(value)) {
        if (value.length === 0) {
          return acc;
        }
        acc[key] = value;
        return acc;
      }
      acc[key] = value;
      return acc;
    }, {});

    for (const [key, value] of Object.entries(sanitizedPayload)) {
      if (!['element','docs_lightbox_id','tags','gif_type','is_tenor'].includes(key)) {
        if (Array.isArray(value)) {
          value.forEach((item) => formData.append(`${key}[]`, item));
          continue;
        }
        formData.append(
          key,
          key === 'file' || typeof value !== 'object'
            ? value
            : JSON.stringify(value)
        );
      }
    }


    if (editElement?.id && elementId) {
      formData.append('_method', 'patch');
    }

    let body, method, url;
    if (payload.file) {
      body   = formData;
      method = (!editElement?.id && !elementId) ? 'POST' : 'PATCH';
      url    = (!editElement?.id && !elementId)
        ? `/docs/elements`
        : `/docs/elements/${editElement.id ?? elementId}`;
    } else {
      headers['Content-Type'] = 'application/json';
      method = (!editElement?.id && !elementId) ? 'POST' : 'PATCH';
      url    = (!editElement?.id && !elementId)
        ? `/docs/elements.json`
        : `/docs/elements/${editElement.id ?? elementId}.json`;
      body = JSON.stringify({
        ...sanitizedPayload,
        ...(toolType === 'Clone' && { duplicate: true }),
      });
    }

    try {
      let response = await fetch(url, {
        method,
        headers,
        body,
        credentials: 'same-origin',
      });

      // Session expired: show login modal, hold the save, retry after re-auth.
      if (response.status === 401) {
        if (typeof window !== 'undefined' && window.__REQUIRES_AUTH__ && !window.__SESSION_TIMEOUT_ACTIVE__) {
          window.__SESSION_TIMEOUT_ACTIVE__ = true;
          window.dispatchEvent(new CustomEvent('app:session-expired'));
        }
        await new Promise((resolve) => {
          const handler = () => {
            window.removeEventListener('app:session-restored', handler);
            resolve();
          };
          window.addEventListener('app:session-restored', handler);
        });
        const freshToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        response = await fetch(url, {
          method,
          headers: { ...headers, 'X-CSRF-Token': freshToken || headers['X-CSRF-Token'] },
          body,
          credentials: 'same-origin',
        });
      }

      if (!response.ok) throw new Error(`Server returned ${response.status}`);

      const jsonResponse = await response.json();
      if (toolType !== 'LightboxesToolbox') {
        setShowToast({
          showToast:    true,
          toastType:    'success',
          toastMessage: editElement?.id ? 'Changes Saved' : 'Element Created',
        });
      }

      if (payload.element_type === '4' && payload.file && elementId) {
        const { file, ...updatedTool } = tool;
        handleSave(updatedTool);
      }

      setElements(prev => ({ ...prev, [jsonResponse.id]: jsonResponse }));
      if (elementType === 'image' && toolType === 'LightboxesToolbox') {
        setImageElement(prev => ({ ...prev, [jsonResponse.id]: jsonResponse }));
      }
      handleCloseModal(false);
    } catch (error) {
      console.error('Upload failed:', error);
      setShowToast({
        showToast:    true,
        toastType:    'danger',
        toastMessage: 'Something Went Wrong',
      });
    }
  }

  handleSubmitBtnState();
};


    const removeDiv = () => {
        const divToRemove = document.getElementById("createdDivId");
        if (divToRemove) {
            divToRemove.remove();
        }
        if (editElement?.id) {
            const editDiv = document.getElementById(`div${editElement?.id}`)
            const editImage = document.getElementById(`image${tool?.id}`)
            if (editImage) {
                editImage.style.transform = `rotate(${editElement?.rotate ?? 0}deg) scaleX(${editElement?.flip ?? 1})`
            }
            if (editDiv) {
                editDiv.style.width = `${normalizeDimensions(editElement?.geometry?.width, 1, zoom?.value)}px`
                editDiv.style.height = `${normalizeDimensions(editElement?.geometry?.height, 1, zoom?.value)}px`;
            }
        }
    };

    // handle element modal close
    const handleCloseModal = (status) => {
        setTool({})
        setEditElement({})
        removeDiv()
        setToolType('')
        closeModal && closeModal(status)
        setEditEnabled(status)
        localStorage.removeItem('is_changed_model');
        if (window.tinymce) {
            window.tinymce.remove();
        }
        document.querySelectorAll('.tox-tinymce-aux').forEach(el => el.remove());
        handleSubmitBtnState();
        //close
        const canvas = document.getElementById(tool?.page);
        if (canvas) {
          const ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
    }

    // dynamically render element section with heading and component
    const ToolSection = () => {
        let result = {
            header: "",
            component: null,
        };
        switch (true) {
            case toolType === 'ImageToolbox' || editElement?.element_type === 4:
                result.header = toolType === 'Clone' ? 'Clone Element' : Object.values(editElement).length > 0 ? `Image settings ${editElement.id}` : "Add Image";
                result.component = (
                    <ImageSection
                        tool={tool}
                        handleImageUpload={handleImageUpload}
                        uploadElement={handleSubmitElement}
                        editElement={editElement}
                        handleSelectGifs={handleSelectGifs}
                        errorState={errorState}
                    />
                );
                break;
            case toolType === 'VideoToolbox' || editElement?.element_type === 5:
                result.header = toolType === 'Clone' ? 'Clone Element' : Object.values(editElement).length > 0 ? 'Video settings' : "Add Video";
                result.component = (
                    <VideoSection
                        handleVideoUrlUpload={handleElementUpload}
                        videoLink={tool?.value?.video_link}
                        errorState={errorState}
                    />
                );
                break;
            case toolType === 'TextToolbox' || editElement?.element_type === 7:
                result.header = toolType === 'Clone' ? 'Clone Element' : Object.values(editElement).length > 0 ? 'Text settings' : "Add Text";
                result.component = (
                    <TextEditorSection
                        handleTextChange={handleTextChange}
                        html_text={tool?.value?.html_text}
                        errorState={errorState}
                        totalPages={totalPages}
                        currentPage={tool?.page}
                    />
                );
                break;
            case toolType === 'EmbedToolbox' || editElement?.element_type === 6:
                result.header = toolType === 'Clone' ? 'Clone Element' : Object.values(editElement).length > 0 ? 'Embed settings' : "Add Embed";
                result.component = (
                    <EmbedSection
                        handleEmbedUrlUpload={handleElementUpload}
                        siteUrl={tool?.value?.video_link}
                        preventScroll={tool?.value?.no_scroll}
                        errorState={errorState}
                    />
                );
                break;
            case toolType === 'HotspotToolbox' || editElement?.element_type === 9:
                result.header = toolType === 'Clone' ? 'Clone Element' : Object.values(editElement).length > 0 ? 'Hotspot settings' : "Add Hotspot";
                result.component = (
                    <HotspotSection
                        tool={tool}
                        setTool={setTool}
                        handleHotspotUpload={handleElementUpload}
                        uploadElement={handleSubmitElement}
                    />
                );
                break;
            default:
                result.header = toolType === 'Clone' ? 'Clone Element' : Object.values(editElement).length > 0 ? `Image settings` : "Add Image";
                result.component = (
                    <ImageSection
                        tool={tool}
                        handleImageUpload={handleImageUpload}
                        uploadElement={handleSubmitElement}
                        editElement={editElement}
                        handleSelectGifs={handleSelectGifs}
                        errorState={errorState}
                    />
                );
        }
        return result;
    }

    // api call to send the lightbox id when images are added in the slider.
    const editImageInSlider = async (editId, data) => {
        const response = await networkService(`/docs/elements/${editId}.json`, 'PATCH', data)
        return response
    }

    //handle validations
    const scrollToFirstError = () => {
        // Wait for error state to update, then scroll to first error
        setTimeout(() => {
            const errorSelectors = [
                '.text-danger',  // Error messages
                '.invalid-color', // Invalid color input
                'input.is-invalid', // Bootstrap invalid class
                'textarea.is-invalid',
                'select.is-invalid'
            ];

            for (const selector of errorSelectors) {
                const errorElement = document.querySelector(`.elementModal-body ${selector}`);
                if (errorElement) {
                    errorElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                    break;
                }
            }
        }, 100);
    };

    const handleValidations = (tool) => {
        if (!tool?.value?.video_link &&
            (toolType === "VideoToolbox" ||
                toolType === "EmbedToolbox" ||
                editElement?.element_type === 6 ||
                editElement?.element_type === 5)
        ) {
            setErrorState({
                ...errorState,
                videoErr: 'Please add the embed code provided by youtube or vimeo. Link must contain http or https.',
                embedErr: 'Please add the URL. Link must contain http or https.'
            })
            scrollToFirstError();
            return false
        }
        else if (!tool?.value?.html_text && (toolType === "TextToolbox" ||
            editElement?.element_type === 7)) {
            setErrorState({
                ...errorState,
                textErr: 'Please add the text'
            })
            scrollToFirstError();
            return false
        } else if (
            (toolType === 'ImageToolbox' || editElement?.element_type === 4) &&
            (!tool?.file && !tool?.file_url && !tool?.value?.gif_link)
        ) {
            setErrorState({
                ...errorState,
                imgErr: 'Please select the Image Element'
            })
            scrollToFirstError();
            return false
        } else if (!tool?.tags?.length && (
            actionKeys.some((key) => tool?.value?.hasOwnProperty(key)) ||
            Object.keys(tool?.dropdown_data || {}).length > 0
        ) && tool?.action != 'none') {
            setErrorState({
                ...errorState,
                tagErr: 'Please add a tag'
            })
            scrollToFirstError();
            return false
        }
        else if (

            tool?.action === 'page' &&
            (
                Number(tool?.value?.page_link) === 0 ||
                Number(tool?.value?.page_link) > Number(totalPages) ||
                Number(tool?.value?.page_link) === Number(tool?.page)
            )
        ) {
            //todo
             if (Number(tool?.value?.page_link) === Number(tool?.page) ) {
                            setErrorState((prev) => ({
                                ...prev,
                                pageErr: "Please add a page number other than current page",
                            }));
                        }
            setErrorState({
                ...errorState,
                pageErr: Number(tool?.value?.page_link) === Number(tool?.page) ?
                    'Please add a page number other than current page' :
                    tool?.value?.page_link == 0 ?
                        'Please add a valid page number' :
                        'Please add a valid page number'
            })
            scrollToFirstError();
            return false
        }
        else if (tool?.action === 'link_and_jump') {
            const hasLjLink = !!(tool?.value?.lj_url || tool?.value?.lj_mail || tool?.value?.lj_phone);
            const hasLjPage = !!tool?.value?.lj_page_link;
            if (hasLjLink && !hasLjPage) {
                setErrorState({
                    ...errorState,
                    ljErr: 'Please add a page number for Jump to'
                })
                scrollToFirstError();
                return false
            } else if (!hasLjLink && hasLjPage) {
                setErrorState({
                    ...errorState,
                    ljErr: 'Please add a URL, E-Mail or Phone for Link to'
                })
                scrollToFirstError();
                return false
            } else if (!hasLjLink && !hasLjPage) {
                setErrorState({
                    ...errorState,
                    ljErr: 'Please fill in both Link to and Jump to fields'
                })
                return false
            } else if (
                Number(tool?.value?.lj_page_link) === 0 ||
                Number(tool?.value?.lj_page_link) > Number(totalPages) ||
                Number(tool?.value?.lj_page_link) === Number(tool?.page)
            ) {
                setErrorState({
                    ...errorState,
                    ljErr: Number(tool?.value?.lj_page_link) === Number(tool?.page) ?
                        'Please add a page number other than current page' :
                        'Please add a valid page number'
                })
                return false
            }
            return true
        }
        else {
            return true
        }
    }

    useEffect(() => {
        if (editElement.id) {
            const { docs_element_tags, action, geometry, ...rest } = editElement;
            
            // For video/embed elements, try to extract dimensions from video_link if it's an iframe
            // and embed_dimensions don't exist
            let embedDimensions = rest.embed_dimensions || rest.value?.embed_dimensions;
            
            if (!embedDimensions && (rest.element_type === 5 || rest.element_type === 6 || rest.element_type === 8)) {
                const videoLink = rest.value?.video_link;
                if (videoLink && typeof videoLink === 'string' && videoLink.match(/^<iframe(.*?)><\/iframe>/gi)) {
                    const widthMatch = videoLink.match(/width=["']?(\d+)["']?/i);
                    const heightMatch = videoLink.match(/height=["']?(\d+)["']?/i);
                    
                    if (widthMatch && widthMatch[1] && heightMatch && heightMatch[1]) {
                        embedDimensions = {
                            width: parseInt(widthMatch[1], 10),
                            height: parseInt(heightMatch[1], 10)
                        };
                    }
                }
            }
            
            // Determine reactivate_scroll value from saved data
            const reactivateScrollValue = rest.value?.reactivate_scroll === true ||
                                          rest.value?.reactivate_scroll === 'true' ||
                                          rest.value?.reactive === 'reactive';

            const updatedElement = {
                ...rest,
                _baseGeometry: { ...geometry },
                geometry: {
                    ...geometry,
                    ...getNormalizedDimensions(geometry, zoom, pageDimensions)
                },
                action: action ?? 'none',
                tags: docs_element_tags || [],
                value: {
                    ...rest.value,
                    reactivate_scroll: reactivateScrollValue,
                    reactive: reactivateScrollValue ? 'reactive' : '',
                    ...(embedDimensions && { embed_dimensions: embedDimensions })
                },
                ...(embedDimensions && { embed_dimensions: embedDimensions })
            };
            setTool(updatedElement);
            // Sync scrollActive state with loaded element data
            setScrollActive(reactivateScrollValue);
            sessionStorage.setItem("scrolling", reactivateScrollValue);
        }
    }, [editElement])

    useEffect(() => {
        const divCreated = document.getElementById("createdDivId");
        if (tool?.id) {
            const editImage = document.getElementById(`image${tool?.id}`)
            if (editImage) {
                editImage.style.transform = `rotate(${tool?.rotate ?? 0}deg) scaleX(${tool?.flip ?? 1})`
            }
        } else if (divCreated) {
            divCreated.style.zIndex = 999;
            divCreated.style.width = `${tool?.geometry?.width}px`;
            divCreated.style.height = `${tool?.geometry?.height}px`;
            divCreated.style.top = `${tool?.geometry?.top}px`;
            divCreated.style.left = `${tool?.geometry?.left}px`;
        }
    }, [tool])

   const  geomatryAccordigToNormal=()=>{
    
     const { docs_element_tags, action, geometry, ...rest } = editElement;
           
        return getNormalizedDimensions(geometry, zoom, pageDimensions)
   }

    return {
        tool,
        ToolSection,
        handleCloseModal,
        handleSubmitElement,
        uploadElement,
        handleChange,
        toolType,
        editElement,
        handleElementUpload,
        setTool,
        editImageInSlider,
        handleTextChange, scrollActive,
        isChanged, setIsChanged,
        errorState,
        handleSubmitBtnState,
        showExtendModal,setShowExtendModal,geomatryAccordigToNormal
    };
};

export default useEditorHook;
